/**
 * The one catalogue of user-facing failure texts (ADR 0006): `ErrorCode` and the
 * password rules in Turkish and English. Every client merges it into its own i18n
 * resources under the `errors` and `passwordRules` namespaces, so a new code is
 * translated once. Plural keys follow the i18next `_one`/`_other` convention and
 * carry a `{{count}}` placeholder.
 */

export const errorResourcesTr = {
  errors: {
    title: 'Bir sorun oluştu',
    generic: 'Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.',
    network: 'Sunucuya ulaşılamıyor. Bağlantınızı kontrol edin.',
    timeout: 'İstek zaman aşımına uğradı.',
    VALIDATION_ERROR: 'Gönderilen bilgiler geçersiz.',
    NOT_FOUND: 'İstenen öğe bulunamadı.',
    CONFLICT: 'Bu işlem şu anki durumla çakışıyor.',
    RATE_LIMITED: 'Çok fazla deneme yaptınız. Lütfen biraz bekleyin.',
    PAYLOAD_TOO_LARGE: 'Gönderilen içerik çok büyük.',
    INTERNAL_ERROR: 'Sunucu hatası. Lütfen daha sonra tekrar deneyin.',
    SERVICE_UNAVAILABLE: 'Servis geçici olarak kullanılamıyor.',
    UNAUTHORIZED: 'Oturumunuz doğrulanamadı. Lütfen tekrar giriş yapın.',
    FORBIDDEN: 'Bu işlem için yetkiniz yok.',
    INVALID_CREDENTIALS: 'E-posta adresi veya parola hatalı.',
    ACCESS_TOKEN_EXPIRED: 'Oturum süresi doldu, yenileniyor…',
    REFRESH_TOKEN_INVALID: 'Oturumunuz sona erdi. Lütfen tekrar giriş yapın.',
    REFRESH_TOKEN_REUSED: 'Güvenlik nedeniyle oturumunuz kapatıldı. Lütfen tekrar giriş yapın.',
    SESSION_REVOKED: 'Bu oturum sonlandırıldı.',
    SESSION_EXPIRED: 'Oturumunuz zaman aşımına uğradı. Lütfen tekrar giriş yapın.',
    TOO_MANY_ATTEMPTS: 'Çok fazla başarısız giriş denemesi. Lütfen biraz bekleyin.',
    ORIGIN_NOT_ALLOWED: 'Bu istek güvenlik nedeniyle reddedildi. Sayfayı yenileyip tekrar deneyin.',
    TENANT_NOT_FOUND: 'Bu e-posta alan adı için hizmet tanımlı değil.',
    ACCOUNT_DISABLED: 'Hesabınız etkin değil. Yöneticinizle görüşün.',
    PASSWORD_CHANGE_REQUIRED: 'Devam etmek için parolanızı değiştirmeniz gerekiyor.',
    PASSWORD_CHANGE_NOT_REQUIRED: 'Bu hesabın parolasını değiştirmesi gerekmiyor. Her zamanki gibi giriş yapın.',
    TWO_FACTOR_CODE_INVALID: 'Kod hatalı. Lütfen tekrar deneyin.',
    TWO_FACTOR_EXPIRED: 'Doğrulamanın süresi doldu. Lütfen yeniden başlayın.',
    TWO_FACTOR_UNAVAILABLE: 'İki adımlı doğrulama şu anda kullanılamıyor.',
    PHONE_NUMBER_INVALID: 'Bu telefon numarası kullanılamıyor.',
    PHONE_NUMBER_MISSING: 'Hesabınızda kayıtlı bir cep telefonu yok; doğrulama kodu gönderilemiyor. Yöneticinizle görüşün.',
    SMS_SEND_FAILED: 'Doğrulama kodu gönderilemedi. Lütfen biraz sonra tekrar deneyin.',
    DEVICE_NOT_FOUND: 'Cihaz kaydı bulunamadı.',
    MAIL_SERVER_UNAVAILABLE: 'Posta sunucusuna şu anda ulaşılamıyor.',
    MAIL_SERVER_ERROR: 'Posta sunucusu bir hata döndürdü.',
    MAIL_SERVER_AUTH_EXPIRED: 'Posta sunucusu oturumu sona erdi. Lütfen tekrar giriş yapın.',
    MAIL_SERVER_PERMISSION_DENIED: 'Posta sunucusu bu işleme izin vermedi.',
    MAIL_SERVER_QUOTA_EXCEEDED: 'Posta kutunuz dolu.',
    ATTACHMENT_TOO_LARGE: 'Ek çok büyük.',
    SEND_FAILED: 'E-posta gönderilemedi.',
    INVALID_RECIPIENT: 'Alıcı adresi geçersiz.',
    UPLOAD_EXPIRED: 'Ek yüklemesinin süresi doldu, lütfen tekrar ekleyin.',
    UNSUPPORTED_MEDIA_TYPE: 'Bu dosya türü desteklenmiyor.',
    PASSWORD_POLICY_VIOLATION: 'Yeni parola, parola kurallarını karşılamıyor.',
    PASSWORD_RECENTLY_USED: 'Bu parolayı yakın zamanda kullandınız. Farklı bir parola seçin.',
    PASSWORD_CHANGE_TOO_SOON:
      'Parolanız kısa süre önce değiştirildi; şimdilik yeniden değiştirilemez.',
    PASSWORD_CHANGE_NOT_ALLOWED: 'Bu hesabın parolası değiştirilemiyor. Yöneticinizle görüşün.',
    PASSWORD_LOCKED: 'Parolanız kilitli ve değiştirilemez. Yöneticinizle görüşün.',
    MESSAGE_TOO_LARGE: 'İleti, posta sunucusunun kabul ettiği boyutu aşıyor.',
  },
  passwordRules: {
    minLength_one: 'En az {{count}} karakter olmalı.',
    minLength_other: 'En az {{count}} karakter olmalı.',
    maxLength_one: 'En fazla {{count}} karakter olabilir.',
    maxLength_other: 'En fazla {{count}} karakter olabilir.',
    minUpperCase_one: 'En az {{count}} büyük harf içermeli.',
    minUpperCase_other: 'En az {{count}} büyük harf içermeli.',
    minLowerCase_one: 'En az {{count}} küçük harf içermeli.',
    minLowerCase_other: 'En az {{count}} küçük harf içermeli.',
    minDigits_one: 'En az {{count}} rakam içermeli.',
    minDigits_other: 'En az {{count}} rakam içermeli.',
    minPunctuation_one: 'En az {{count}} noktalama işareti veya sembol içermeli.',
    minPunctuation_other: 'En az {{count}} noktalama işareti veya sembol içermeli.',
    minDigitsOrPunctuation_one: 'En az {{count}} rakam veya sembol içermeli.',
    minDigitsOrPunctuation_other: 'En az {{count}} rakam veya sembol içermeli.',
    minLetters_one: 'En az {{count}} harf içermeli.',
    minLetters_other: 'En az {{count}} harf içermeli.',
    allowedChars: 'İzin verilmeyen bir karakter içeriyor.',
    containsUsername: 'Kullanıcı adınızı içermemeli.',
    common: 'Bu parola çok yaygın; tahmin edilmesi zor bir parola seçin.',
  },
} as const;

export const errorResourcesEn = {
  errors: {
    title: 'Something went wrong',
    generic: 'An unexpected error occurred. Please try again.',
    network: 'Cannot reach the server. Check your connection.',
    timeout: 'The request timed out.',
    VALIDATION_ERROR: 'The submitted data is invalid.',
    NOT_FOUND: 'The requested item was not found.',
    CONFLICT: 'This action conflicts with the current state.',
    RATE_LIMITED: 'Too many attempts. Please wait a moment.',
    PAYLOAD_TOO_LARGE: 'The content is too large.',
    INTERNAL_ERROR: 'Server error. Please try again later.',
    SERVICE_UNAVAILABLE: 'The service is temporarily unavailable.',
    UNAUTHORIZED: 'Your session could not be verified. Please sign in again.',
    FORBIDDEN: 'You are not allowed to do this.',
    INVALID_CREDENTIALS: 'E-mail address or password is incorrect.',
    ACCESS_TOKEN_EXPIRED: 'Session expired, refreshing…',
    REFRESH_TOKEN_INVALID: 'Your session has ended. Please sign in again.',
    REFRESH_TOKEN_REUSED: 'Your session was closed for security reasons. Please sign in again.',
    SESSION_REVOKED: 'This session was revoked.',
    SESSION_EXPIRED: 'Your session timed out. Please sign in again.',
    TOO_MANY_ATTEMPTS: 'Too many failed sign-in attempts. Please wait a moment.',
    ORIGIN_NOT_ALLOWED:
      'This request was refused for security reasons. Reload the page and try again.',
    TENANT_NOT_FOUND: 'This e-mail domain is not served here.',
    ACCOUNT_DISABLED: 'Your account is not active. Contact your administrator.',
    PASSWORD_CHANGE_REQUIRED: 'You need to change your password to continue.',
    PASSWORD_CHANGE_NOT_REQUIRED: 'This account does not need a new password. Sign in as usual.',
    TWO_FACTOR_CODE_INVALID: 'The code is incorrect. Please try again.',
    TWO_FACTOR_EXPIRED: 'The verification has expired. Please start again.',
    TWO_FACTOR_UNAVAILABLE: 'Two-step verification is not available right now.',
    PHONE_NUMBER_INVALID: 'This phone number cannot be used.',
    PHONE_NUMBER_MISSING: 'Your account has no mobile number on record, so no code can be sent. Contact your administrator.',
    SMS_SEND_FAILED: 'The verification code could not be sent. Please try again in a moment.',
    DEVICE_NOT_FOUND: 'Device registration not found.',
    MAIL_SERVER_UNAVAILABLE: 'The mail server is not reachable right now.',
    MAIL_SERVER_ERROR: 'The mail server returned an error.',
    MAIL_SERVER_AUTH_EXPIRED: 'The mail server session expired. Please sign in again.',
    MAIL_SERVER_PERMISSION_DENIED: 'The mail server did not allow this action.',
    MAIL_SERVER_QUOTA_EXCEEDED: 'Your mailbox is full.',
    ATTACHMENT_TOO_LARGE: 'Attachment is too large.',
    SEND_FAILED: 'The e-mail could not be sent.',
    INVALID_RECIPIENT: 'Recipient address is invalid.',
    UPLOAD_EXPIRED: 'The attachment upload expired, please attach it again.',
    UNSUPPORTED_MEDIA_TYPE: 'This file type is not supported.',
    PASSWORD_POLICY_VIOLATION: 'The new password does not meet the password rules.',
    PASSWORD_RECENTLY_USED: 'You used this password recently. Choose a different one.',
    PASSWORD_CHANGE_TOO_SOON: 'Your password was changed recently and cannot be changed again yet.',
    PASSWORD_CHANGE_NOT_ALLOWED:
      'Password changes are turned off for this account. Contact your administrator.',
    PASSWORD_LOCKED: 'Your password is locked and cannot be changed. Contact your administrator.',
    MESSAGE_TOO_LARGE: 'The message is larger than the mail server accepts.',
  },
  passwordRules: {
    minLength_one: 'Must be at least {{count}} character long.',
    minLength_other: 'Must be at least {{count}} characters long.',
    maxLength_one: 'Can be at most {{count}} character long.',
    maxLength_other: 'Can be at most {{count}} characters long.',
    minUpperCase_one: 'Must contain at least {{count}} upper-case letter.',
    minUpperCase_other: 'Must contain at least {{count}} upper-case letters.',
    minLowerCase_one: 'Must contain at least {{count}} lower-case letter.',
    minLowerCase_other: 'Must contain at least {{count}} lower-case letters.',
    minDigits_one: 'Must contain at least {{count}} digit.',
    minDigits_other: 'Must contain at least {{count}} digits.',
    minPunctuation_one: 'Must contain at least {{count}} punctuation mark or symbol.',
    minPunctuation_other: 'Must contain at least {{count}} punctuation marks or symbols.',
    minDigitsOrPunctuation_one: 'Must contain at least {{count}} digit or symbol.',
    minDigitsOrPunctuation_other: 'Must contain at least {{count}} digits or symbols.',
    minLetters_one: 'Must contain at least {{count}} letter.',
    minLetters_other: 'Must contain at least {{count}} letters.',
    allowedChars: 'Contains a character that is not allowed.',
    containsUsername: 'Must not contain your user name.',
    common: 'This password is too common. Choose one that is hard to guess.',
  },
} as const;

/** Both languages, keyed by language code. */
export const errorResources = { tr: errorResourcesTr, en: errorResourcesEn } as const;

/** Languages the catalogue covers. */
export type ErrorResourceLanguage = keyof typeof errorResources;
